import { type HttpEvent, HttpHandler, type HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = localStorage.getItem('locale') || 'en-US';

    const clonedReq = req.clone({
      setHeaders: {
        'Accept-Language': language
      }
    });

    return next.handle(clonedReq);
  }
}
